{
  "version": 1,
  "asset_id": "1e3fa8ee-fd02-48d2-9113-e525da87a0a6",
  "project_id": "1e2975bf-5ed0-490a-887a-32746528c0b1",
  "url": "/__l5e/assets-v1/1e3fa8ee-fd02-48d2-9113-e525da87a0a6/logo-terra.svg",
  "r2_key": "a/v1/1e2975bf-5ed0-490a-887a-32746528c0b1/1e3fa8ee-fd02-48d2-9113-e525da87a0a6/logo-terra.svg",
  "original_filename": "logo-terra.svg",
  "size": 5922,
  "content_type": "image/svg+xml",
  "created_at": "2026-09-21T21:42:07Z"
}
